import React from 'react'
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import axios from 'axios'
import exportValue from '../../apiconfig'
import Swal from 'sweetalert2'
import Moment from "react-moment";

const Notification_log = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    const [state,setState]=React.useState({

        notifications:[],
        from_date:'',
        to_date:''
        
        })
        
        
        React.useEffect(()=>{
        
        getNotifications();
        
        },[])
        
        
        
        const getNotifications=()=>{
        
        
        axios.post(
        
        exportValue.host+"/"+
        exportValue.version+"/"+
        exportValue.api+
        "/notification_log",
        
        
        {
        
        from_date:state.from_date,
        
        to_date:state.to_date
        
        },
        
        {
        
        headers:exportValue.headers
        
        }
        
        )
        
        .then(res=>{
        
        
        if(res.data.status){
        
        
        setState(prev=>({
        
        ...prev,
        
        notifications:res.data.notifications
        
        }))
        
        
        }
        
        
        })
        
        
        .catch(err=>{
        
        console.log(err)
        
        })
        
        
        }
        
        
        
        
        const filterNotifications=()=>{
        
        getNotifications();
        
        }
        
        
        
        const openNotification=async(item)=>{
        
        
        try{
        
        
        if(!item.is_read){
        
        
        await axios.post(
        
        exportValue.host+"/"+
        exportValue.version+"/"+
        exportValue.api+
        "/mark_notification_read",
        
        
        {
        
        notification_id:item._id
        
        },
        
        {
        
        headers:exportValue.headers
        
        }
        
        
        )
        
        
        }
        
        
        
        
        window.location.href=item.redirect_url;
        
        
        }
        
        catch(e){
        
        console.log(e)
        
        }
        
        
        }
        
        
  return (
    <div>
     

<Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
<section class="home-section">
<Sub_header/>
<div className="container-fluid">


<div className="card mt-3">


<div className="card-header">


<h4>

Notification Logs

</h4>


</div>




<div className="card-body">



<div className="row mb-4">


<div className="col-md-3">


<label>

From Date

</label>



<input

type="date"

className="form-control"

value={state.from_date}

onChange={(e)=>setState({

...state,

from_date:e.target.value

})}

/>


</div>





<div className="col-md-3">


<label>

To Date

</label>



<input

type="date"

className="form-control"

value={state.to_date}

onChange={(e)=>setState({

...state,

to_date:e.target.value

})}

/>


</div>




<div className="col-md-2 mt-4">


<button

className="btn btn-primary"

onClick={filterNotifications}

>

Search


</button>


</div>




</div>








<div className="jp-notification-log">
  <div className="card jp-notification-card shadow-sm border-0">
    <div className="card-header bg-white">
      <h5 className="mb-0 fw-bold">Notifications</h5>
    </div>

    <div className="table-responsive">
      <table className="table mb-0 jp-notification-table">
        <thead>
          <tr>
            <th width="70">Status</th>
            <th>Notification</th>
            <th width="180">Date & Time</th>
            <th width="120" className="text-center">
              Action
            </th>
          </tr>
        </thead>

        <tbody>
          {state.notifications.length > 0 ? (
            state.notifications.map((item) => (
              <tr
                key={item._id}
                className={!item.is_read ? "jp-notification-unread" : ""}
              >
                <td>
                  {!item.is_read ? (
                    <i className="fa fa-envelope jp-unread-icon"></i>
                  ) : (
                    <i className="fa fa-envelope-open jp-read-icon"></i>
                  )}
                </td>

                <td>
                  <div className="jp-notification-title">
                    {item.title}
                  </div>

                  <div className="jp-notification-message">
                    {item.message}
                  </div>
                </td>

                <td className="jp-notification-date">
                  <Moment format="DD MMM YYYY hh:mm A">
                    {item.created_at * 1000}
                  </Moment>
                </td>

                <td className="text-center">
                  <button
                    className="btn btn-sm jp-view-btn"
                    onClick={() => openNotification(item)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">
                <div className="jp-empty-notification">
                  <i className="fa fa-bell-slash"></i>
                  <p>No Notifications Found</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
</div>

</div>
</div>
</div>

</section>
    </div>
  )
}

export default Notification_log
